import React, { Fragment, useEffect, useState } from "react";
import Navbar2 from "../../components/Navbar2/Navbar2";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import { PortableText } from "@portabletext/react";
import client, { urlFor } from "../../sanity/sanityClient";

const EventPage = () => {
  const [events, setEvents] = useState([]);

  useEffect(() => {
    // Fetch all events
    client
      .fetch(
        `*[_type == "event"] | order(date desc) {
          title,
          slug,
          date,
          time,
          location,
          mainImage,
          body,
          cta
        }`
      )
      .then((data) => {
        setEvents(data);
      })
      .catch(console.error);
  }, []);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
  };

  return (
    <Fragment>
      <Navbar2 />
      <PageTitle pageTitle={"Events"} pagesub={"Events"} />
      <div className="event-list" style={{ padding: "20px" }}>
        {events.map((event) => (
          <div
            key={event.slug.current}
            className="event-card"
            style={{
              marginBottom: "20px",
              padding: "20px",
              border: "1px solid #ddd",
              borderRadius: "8px",
              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
            }}
          >
            {/* Main Image */}
            {event.mainImage && (
              <img
                src={urlFor(event.mainImage).url()}
                alt={event.title}
                className="event-image"
                style={{
                  width: "100%",
                  borderRadius: "8px",
                  marginBottom: "15px",
                }}
              />
            )}

            {/* Title and Details */}
            <h2 style={{ marginBottom: "10px" }}>{event.title}</h2>
            <p>
              <strong>Date:</strong> {formatDate(event.date)}
            </p>
            <p>
              <strong>Time:</strong> {event.time}
            </p>
            <p>
              <strong>Location:</strong> {event.location}
            </p>

            {/* Body Content */}
            <div className="event-body" style={{ marginTop: "15px" }}>
              <PortableText value={event.body} />
            </div>

            {/* CTA Button */}
            {event.cta && (
              <a
                href={event.cta.ctaLink}
                className="cta-button"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: "inline-block",
                  marginTop: "15px",
                  padding: "10px 20px",
                  backgroundColor: "#007bff",
                  color: "#fff",
                  borderRadius: "5px",
                  textDecoration: "none",
                  fontWeight: "bold",
                }}
              >
                {event.cta.ctaText}
              </a>
            )}
          </div>
        ))}
      </div>
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};

export default EventPage;
